module.exports = __webpack_public_path__ + "img/offers.monthly.d615bd2f.png";